import React, { useState, useEffect } from "react";
import {Grid } from '@material-ui/core';
import { Box, Card, CardContent, FormControl, InputLabel, Alert, AlertTitle, Button, Dialog, DialogTitle, DialogContentText, DialogActions, Select, MenuItem } from '@mui/material';
import MainCard from '../components/MainCard';
import StickyHeadTwoButtonTable from '../components/StickyHeadTwoButtonTable';
import StickyHeadCombineRowTable from '../components/Table/StickyHeadCombineRowTable';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';
import LineChart from '../components/Chart/LineChart';
import DialogContent from '@mui/material/DialogContent';
import InClassStressChart from '../components/InClassStressChart';


const PerformancePage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [isBootTime, setIsBootTime] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [isEmmc, setIsEmmc] = useState(false);
  const [noDataMessage, setNoDataMessage] = useState('');
  const [openSummary, setOpenSummary] = useState(false);
  const [series, setSeries] = useState([]);
  const [mapEmmc, setMapEmmc] = useState(new Map());
  const [category, setCategory] = useState([]);
  const [showSummary, setShowSummary] = useState(true);
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [deleteReq, setDeleteReq] = useState({});
  const [inclassData, setInclassData] = useState({});
  const [projectList, setProjectList] = useState([]);
  const [project, setProject] = useState("");
  const [decimal, setDecimal] = useState(0);
  const [lineWidth, setLineWidth] = useState([]);
  const [lineDash, setLineDash] = useState([]);
  const [title, setTitle] = useState([]);
  const [title2, setTitle2] = useState([]);
  const [title2G, setTitle2G] = useState('');
  const [title2G2, setTitle2G2] = useState('');
  const [series2, setSeries2] = useState([]);
  const [series2G, setSeries2G] = useState([]);
  const [series2G2, setSeries2G2] = useState([]);
  const [category2G, setCategory2G] = useState([]);
  const [emmcRawCategory, setEmmcRawCategory] = useState([]);
  const [maxWidth, setMaxWidth] = useState('sm');
  function handlProject(e) {
        setTestVersion("");
        setInclassProject("");
        setTestBy("");
        setTestVersionList([]);
        setTestSuite("");
        setShowVersion(false);
        setProject(e.target.value);
  }

  const [showInClassChart, setShowInClassChart] = useState(false);
  const [testSuiteList, setTestSuiteList] = useState([]);
  const [testSuite, setTestSuite] = useState("");
  function handleTestSuite(e) {
        setTestSuite(e.target.value);
        if (e.target.value.includes("in-class-check")){
          setTestVersion("");
          setInclassProject("");
          setTestVersionList([]);
          getVersionOptions(project, buildType, e.target.value);
          setShowVersion(true);
        }else{
          setShowVersion(false);
        }
  }

  const [buildType, setBuildType] = useState("");
  function handleBuildType(e) {
        setBuildType(e.target.value);
        setTestSuite("");
        getSuiteOptions(e.target.value);
  }

  const [emmcData, setEmmcData] = useState("");
  function handlEmmcData(e) {
    const selected = e.target.value;
    setEmmcData(selected);
    const rawSeries = mapEmmc.get(selected) || [];
    const idx4G = emmcRawCategory.map((c, i) => !c.endsWith(' (2G)') ? i : -1).filter(i => i >= 0);
    const idx2G = emmcRawCategory.map((c, i) =>  c.endsWith(' (2G)') ? i : -1).filter(i => i >= 0);
    const split = (seriesList, indices) =>
      (seriesList || []).map(s => ({ ...s, data: indices.map(i => s.data[i]) }));
    setSeries(split(rawSeries, idx4G));
    setCategory(emmcRawCategory.filter(c => !c.endsWith(' (2G)')));
    if (idx2G.length > 0) {
      setSeries2G(split(rawSeries, idx2G).map(s => ({ ...s, name: s.name + ' (2G)' })));
      setCategory2G(emmcRawCategory.filter(c => c.endsWith(' (2G)')).map(c => c.replace(' (2G)', '')));
    } else {
      setSeries2G([]);
      setCategory2G([]);
    }
  }
  const [inclassProject, setInclassProject] = useState("");
  const [testVersion, setTestVersion] = useState("");
  const [showVersion, setShowVersion] = useState(false);
  function handleTestVersion(e, value) {
    console.log(e.target.value);
    setTestVersion(e.target.value);
    setInclassProject(value.props.name);
  }

  const [testBy, setTestBy] = useState("");
  function handleTestBy(e, value) {
    console.log(e.target.value);
    setTestBy(e.target.value);
  }


  const handleClose = () => {
    setOpenSummary(false);
    setEmmcData('');
  };

  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const styleField = {
    width: '100%',
  };

  const buildTypeOption = [
  { value: 'external'},
  { value: 'user'},
  { value: 'userdebug'},
  { value: 'signed'}]

  const emmcDataOption = [
  { value: 'Count 1'},
  { value: 'Count 2'},
  { value: 'Count 3'},
  { value: 'Count 4'},
  { value: 'Count 5'},
  { value: 'Count 6 after reboot'},
  { value: 'Average'}]

  const second_columns = [
  { id: 'build_number', label: 'Build Number', align: 'left'},
  { id: 'is_2G', label: 'RAM config', align: 'left'},
  { id: 'device_sn', label: 'Device SN', align: 'left'},
  { id: 'suite_name', label: 'Suite Name', align: 'left'},
  { id: 'count_1', label: 'Count 1', align: 'left'},
  { id: 'count_2', label: 'Count 2', align: 'left'},
  { id: 'count_3', label: 'Count 3', align: 'left'},
  { id: 'count_4', label: 'Count 4', align: 'left'},
  { id: 'count_5', label: 'Count 5', align: 'left'},
  { id: 'average', label: 'Average (s)', align: 'left'},
  { id: 'ignore', label: 'Ignore', align: 'center', ignore: true }
];

const TestByOption = [
  { value: 'SystemPerformance'},
  { value: 'QA'},
  { value: 'Remote_Testing'}]

  const getProjectOptions = async () => {
    var input_data = JSON.stringify({ target: "project" })
    const response = await axios.post("/peloton/v1/automation/performance-options", input_data, { withCredentials: true});
    setProjectList(response.data.project_options);
  }

  const getSuiteOptions = async (buildType) => {
    var input_data = JSON.stringify({ target: "buildType", build_type: buildType })
    const response = await axios.post("/peloton/v1/automation/performance-options", input_data, { withCredentials: true});
    setTestSuiteList(response.data.type_options);
  }

  const [testVersionList, setTestVersionList] = useState([]);
  const getVersionOptions = async (project, buildType, testSuite) => {
    var input_data = JSON.stringify({ project: project, build_type: buildType, test_suite: testSuite})
    const response = await axios.post("/peloton/v1/automation/performance-version-options", input_data, { withCredentials: true});
    if (response.data.version_options !== null && response.data.version_options.length > 0){
      setTestVersionList(response.data.version_options);
    }
  }

  useEffect(() => {
    getProjectOptions();
  }, []);

  const handleQueryData = () => {
    if (project === "" || testSuite === ""|| buildType === "" ){
      alert("Please select project, build type and test suite!");
    }else{
      if (testSuite.includes("in-class-check") && testVersion === "" && testBy === ""){
        alert("Please select version and test by!");
      }else{
        setSeries([]);
        setCategory([]);
        setSeries2([]);
        setSeries2G([]);
        setSeries2G2([]);
        setCategory2G([]);
        setEmmcRawCategory([]);
        setRows([]);
        setTitle('');
        setTitle2('');
        setTitle2G('');
        setTitle2G2('');
        setMaxWidth('sm');
        var input_data = JSON.stringify({ project: project, test_suite: testSuite, build_type: buildType, version: testVersion, inclass_project: inclassProject, test_by: testBy})
        axios.post("/peloton/v1/automation/performance-report",input_data,{withCredentials: true})
        .then(response => {
          if (response.data.message === "success") {
            if (response.data.data !== null && response.data.data.length > 0){
              if (testSuite === "BootTime") {
                setIsBootTime(true);
                setLineWidth([ 5, 5 ]);
                setLineDash([ 0, 0 ]);
              }else{
                setIsBootTime(false);
              }

              const allCategory = response.data.chart_category || [];

              if ( testSuite === "EmmcWrite" || testSuite === "EmmcRead" ) {
                // 記住原始 category 供 handlEmmcData 拆分用，不直接 setCategory
                setEmmcRawCategory(allCategory);
                setDecimal(1);
                setMapEmmc(map => new Map(map.set('Count 1', response.data.chart_data)));
                setMapEmmc(map => new Map(map.set('Count 2', response.data.chart_data2)));
                setMapEmmc(map => new Map(map.set('Count 3', response.data.chart_data3)));
                setMapEmmc(map => new Map(map.set('Count 4', response.data.chart_data4)));
                setMapEmmc(map => new Map(map.set('Count 5', response.data.chart_data5)));
                setMapEmmc(map => new Map(map.set('Count 6 after reboot', response.data.chart_data6)));
                setMapEmmc(map => new Map(map.set('Average', response.data.chart_series)));
                setLineWidth([ 5, 3 ]);
                setLineDash([ 0, 10 ]);
              } else {
                // 其他 suite 分割 category：4G 和 2G 各自對應各自的 chart
                const cat4G = allCategory.filter(c => !c.endsWith(' (2G)'));
                const cat2G = allCategory.filter(c => c.endsWith(' (2G)')).map(c => c.replace(' (2G)', ''));
                setCategory(cat4G);
                setCategory2G(cat2G);
                if (testSuite === "RAM") {
                  setDecimal(0);
                } else {
                  setDecimal(5);
                }
                setSeries(response.data.chart_series);
                if (response.data.chart_series_2g && response.data.chart_series_2g.length > 0) {
                  setSeries2G(response.data.chart_series_2g);
                }
                if (response.data.chart_series_2g2 && response.data.chart_series_2g2.length > 0) {
                  setSeries2G2(response.data.chart_series_2g2);
                }
              }
              if ( testSuite === "HomeApp" || testSuite === "OTAService" || testSuite === "DM" ) {
                setSeries2(response.data.chart_series2);
                setTitle("Before OOBE");
                setTitle2("After OOBE");
                setTitle2G("Before OOBE (2G)");
                setTitle2G2("After OOBE (2G)");
                setLineWidth([ 5, 5, 5 ]);
                setLineDash([ 0, 0, 0 ]);
                setDecimal(0);
              }
              if ( testSuite.includes("in-class-check") ) {
                console.log(response.data);
                setInclassData(response.data);
                setMaxWidth('lg');
              }
              setShowSummary(true);
              setColumns(response.data.columns);
              const displayRows = (response.data.data || []).map(row => ({
                ...row,
                is_2G: row.is_2G === 'y' ? '2G' : (row.is_2G === 'n' ? '4G' : row.is_2G),
              }));
              setRows(displayRows);
              setshowAlert(false);
              setshowTable(true);
            }else{
              setNoDataMessage('This condition has no performance data.');
              setshowAlert(true);
              setshowTable(false);
            }
          }else{
            setNoDataMessage('This condition has no performance data.');
            setshowAlert(true);
            setshowTable(false);
          }
        }).catch(err => {
          if (err.message === 'timeout of 3000ms exceeded'){
            setshowAlert(true);
            setNoDataMessage('Too many rows!')
            setshowTable(true);
          }else{
            if (!err.response){
              alert(err)
            }else{
              if (err.response.status === 401){
                navigate("/");
              }else{
                alert(err.response.data.message);
              }
            }
          }
        })
      }
    }
  };

  const handleSummary = () => {
    console.log(testSuite);
    if ( testSuite.includes("in-class-check")) {
      setShowInClassChart(true);
      setOpenSummary(true);
    }else{
      setShowInClassChart(false);
      setOpenSummary(true);
      if ( testSuite === "EmmcWrite" || testSuite === "EmmcRead" ){
        setIsEmmc(true);
        setSeries([]);
      }else{
        setIsEmmc(false);
      }
    }
  };

  const handleDelete = (row) => {
    let input_data = JSON.stringify({ project: project, build_type: buildType, test_suite: testSuite, build_number: row.build_number, device_sn: row.device_sn});
    setDeleteReq(input_data);
    setShowDialogDelete(true);
  };

  const handleDeleteClose = () => {
    setShowDialogDelete(false);
  };

  const deleteTestRecord = () => {
    axios.post("/peloton/v1/automation/remove-performance-report", deleteReq, {withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          handleQueryData()
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
    })
    .finally(() => {
      setDeleteReq({});
      setShowDialogDelete(false);
    })
  };

  return (
    <MainCard title="Automation Reports">
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
      Performance
      </Box>
      <Grid container direction="row" justifyContent="space-around" alignItems="center" >

        <Grid item xs={1}>
          <FormControl style={styleField} >
          <InputLabel id="demo-simple-select-standard-label">Select Project</InputLabel>
            <Select
              id="project"
              fullWidth
              value={project}
              onChange={handlProject}
              variant="filled"
            >
              {projectList.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
            </Grid>
            <Grid item xs={2}>
            <FormControl style={styleField} >
            <InputLabel id="select-build-label">Select Build Type</InputLabel>
              <Select
                id="buildType"
                fullWidth
                value={buildType}
                onChange={handleBuildType}
                variant="filled"
              >
                {buildTypeOption.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
            <Grid item xs={2}>
            <FormControl style={styleField} >
            <InputLabel id="select-suite-label">Select Suite</InputLabel>
              <Select
                id="testSuite"
                fullWidth
                value={testSuite}
                onChange={handleTestSuite}
                variant="filled"
              >
                {testSuiteList.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          { showVersion && (<Grid item xs={2}>
            <FormControl style={styleField} >
            <InputLabel id="select-suite-label">Select Version</InputLabel>
              <Select
                id="testVersion"
                fullWidth
                value={testVersion}
                onChange={handleTestVersion}
                variant="filled"
              >
                {testVersionList.map((option) => (
                  <MenuItem key={option.value} value={option.value} name={option.key}>
                    {option.key}-{option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>)}

          { showVersion && (<Grid item xs={2}>
            <FormControl style={styleField} >
            <InputLabel id="select-suite-label">Select Test by</InputLabel>
              <Select
                id="testBy"
                fullWidth
                value={testBy}
                onChange={handleTestBy}
                variant="filled"
              >
                {TestByOption.map((option) => (
                  <MenuItem key={option.value} value={option.value} name={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>)}

        <Grid item xs={1}>
          <Dialog open={openSummary} onClose={handleClose} maxWidth={maxWidth} scroll='paper' fullWidth>
          <DialogContent dividers>
            { isEmmc && (<FormControl variant="filled" sx={{ width: "100%" }} >
            <InputLabel id="label-emmc">Select data to draw chart</InputLabel>
              <Select
                sx={{ backgroundColor: '#E3F2FD', fontFamily: '"Roboto", "sans-serif"', fontSize: "20px" }}
                id="emmc_data"
                fullWidth
                value={emmcData}
                onChange={handlEmmcData}
                variant="filled"
              >
                {emmcDataOption.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>)}

            {showInClassChart && (<InClassStressChart inclassData={inclassData}/>)}

            {!showInClassChart && (<LineChart isLoading={false} categories={category} series={series} decimal={decimal} lineWidth={lineWidth} lineDash={lineDash} title={title} title2={title2} series2={series2} series2G={series2G} categories2G={category2G} title2G={title2G} series2G2={series2G2} title2G2={title2G2}/>)}
          </DialogContent>
          </Dialog>
        </Grid>
        <Grid item xs={1}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      { showTable && !isBootTime && (<StickyHeadTwoButtonTable rows={rows} columns={columns} showSummary={showSummary} handleSummary={handleSummary} handleDelete={handleDelete}/>)}
      { showTable && isBootTime && (<StickyHeadCombineRowTable rows={rows} columns={second_columns} showSummary={showSummary} handleSummary={handleSummary} handleDelete={handleDelete}/>)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        {noDataMessage}
      </Alert></Card>)}
      <Dialog open={showDialogDelete} onClose={handleDeleteClose} fullWidth>
        <DialogTitle id="alert-dialog-title">
              {"Confirm delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to ignore this test record ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteClose}>Cancel</Button>
          <Button onClick={deleteTestRecord} autoFocus>
          Ignore
          </Button>
        </DialogActions>
      </Dialog>
    </MainCard>)
};

export default PerformancePage;
